import { render, staticRenderFns } from "./ConferenciaCasais.vue?vue&type=template&id=044a4120&scoped=true"
import script from "./ConferenciaCasais.vue?vue&type=script&lang=js"
export * from "./ConferenciaCasais.vue?vue&type=script&lang=js"
import style0 from "./ConferenciaCasais.vue?vue&type=style&index=0&id=044a4120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a4120",
  null
  
)

export default component.exports